import { Alert } from '@ksyos/design-system';
import { getSelectedLanguage } from '../../../../translate';
import { SuccessFlashWhenSaved } from '../../../elements/common';

export interface IAdminProcessesListAlertsProps {
    abortProcessCounter: number;
    correctActionFeedback?: string;
    exportedFinancialReportsMessage?: string;
    hasSearched: boolean;
    incorrectActionFeedback?: string;
    isSearching: boolean;
    processesLength: number;
}

export function AdminProcessesListAlerts(props: IAdminProcessesListAlertsProps) {
    const language = getSelectedLanguage();

    return (
        <>
            {props.correctActionFeedback && <Alert appearance="success">{props.correctActionFeedback}</Alert>}
            {props.incorrectActionFeedback && <Alert appearance="warning">{props.incorrectActionFeedback}</Alert>}

            <SuccessFlashWhenSaved
                message={language.request.successabortProcess}
                savedCounter={props.abortProcessCounter}
            />

            {props.exportedFinancialReportsMessage && (
                <Alert appearance="warning">{props.exportedFinancialReportsMessage}</Alert>
            )}

            {props.processesLength === 0 && !props.isSearching && props.hasSearched && (
                <Alert appearance="info">{language.request.noProcesses}</Alert>
            )}

            {!props.hasSearched && !props.isSearching && (
                <Alert appearance="info">{language.common.performSearch}</Alert>
            )}
        </>
    );
}
